import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  FormGroup
} from 'reactstrap';
import { Button, Tooltip, Row, Col, Modal, Input, Switch, Space, Collapse, Alert } from 'antd';
import {
  PlusOutlined,
  CameraOutlined,
  DeleteOutlined,
  DownOutlined,
  LeftOutlined,
} from '@ant-design/icons';
import { defaultRadioGroupId, defaultEmptyGuid, defaultRadioDasteId } from '../../constants/defaultValues';
import { API_ENDPOINTS } from '../../frameWork/utils/keyapi-endpoints';
import FloatInput from '../../components/Ant/FloatInput';
import FloatTreeSelect from '../../components/Ant/FloatTreeSelect';
import { boolean } from 'yup/lib/locale';
import S_Space from '../../components/S_Space';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { retLastSegmentURL } from '../../utils/retLastSegmentURL';
import { changeFlterDeleteAction, changeFlterEditAction } from '../../redux/actions';
import _ from 'underscore';

interface mytype { modalOpen: boolean, setDialogOpen: any, item: any, isEdit: boolean }

const FilterMenuEditDialog = ({ modalOpen, setDialogOpen, item, isEdit }: mytype) => {
  const { Panel } = Collapse;
  const InputGroup = Input.Group;
  const location = useLocation();
  const dispatch = useDispatch();
  
  const { isLoadingFilter } = useSelector((state: any) => state.DashboardPage, _.isEqual);

  const [listChartPages, setListChartPages] = useState([]);
  const [errorTextlistChartPages, setErrorTextlistChartPages] = useState('');
  const [isEditModeMode, setIsEditMode] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  // useEffect(()=>{
  //   getAllMenuTreeList()
  // },[])
  const onSubmitForm = (values: any) => {
    if (isEdit) {
      // putFilterMenu(values)
      dispatch(changeFlterEditAction({item:values,pageId:retLastSegmentURL(location.pathname)}))
    }

    setDialogOpen(false)
  }

  const formik = useFormik({
    initialValues: {
      id: '',
      sMenuPageId: '',
      sDataSourceId: '',      
      colName: '',
      title: '',
      filterType: ''
    },
    validationSchema: Yup.object({
      title: Yup.string().required('عنوان فیلتر را وارد نمائید'),
    }),
    onSubmit(values) {
      onSubmitForm(values);
    },
  });

  const CloseHandlingModal = () => {
    setDialogOpen();
    formik.resetForm();
  }

  useEffect(() => {
    if (isEdit) {
      formik.values.id = item != null ? item.id : '';
      formik.values.title = item != null ? item.title : '';
      formik.values.colName = item != null ? item.colName : '';
      formik.values.sMenuPageId = item != null ? item.sMenuPageId : '';
      formik.values.sDataSourceId = item != null ? item.sDataSourceId : '';
      formik.values.filterType = item != null ? item.filterType : '';      
      setIsEditMode(true)
    }    
  }, [modalOpen]);



  return (
    <Modal
      width={600}
      style={{ position: 'relative', height: 'calc(100vh - 300px)' }}
      styles={{body:{ overflowY: 'scroll' }}}
      zIndex={1050}
      maskClosable={false}
      destroyOnClose
      open={modalOpen}
      afterClose={CloseHandlingModal}
      title="ویرایش عنوان فیلتر"
      onCancel={setDialogOpen}
      okText="ذخیره"
      cancelText="انصراف"
      footer={
        [
          <Button key="back" onClick={CloseHandlingModal}>
            انصراف
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoadingFilter}
            onClick={() => {
              formik.handleSubmit();
            }}
          >
            ذخیره
          </Button>,
        ]
      }
    >
      <form onSubmit={formik.handleSubmit}>
      {errorMessage != "" && <Alert onClose={()=>setErrorMessage("")} style={{ width: '100%', marginBottom: 5 }} message={errorMessage} type="error" closable />}
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <FormGroup className="form-group">
              <FloatInput
                formik={formik}
                value={formik.values.title}
                label="عنوان فیلتر"
                placeholder="عنوان فیلتر را وارد نمائید"
                name="title"
              />
            </FormGroup>
          </Col>
        </Row>
      </form>
    </Modal>
  );
};

export default FilterMenuEditDialog;
